import MapView from '@arcgis/core/views/MapView';
import { MapPlugin } from '../arcgis-types';
import PublicFSLBuilder, { FSLBuilder } from './utils/public-fsl-builder';
import { Layer } from '../../../models/layer-settings';
import { debugLog, LayerState } from './utils/layer-change-coordinator';

export const FULCRUM_PUBLIC_FSL_LAYER_PREFIX = 'FULCRUM_PUBLIC_FSL_LAYER_';

let builder: FSLBuilder;

export const isPublicFSL = (layer: Layer) => layer.type === 'feature-service' && layer.origin === 'fulcrum';

const PublicFeatureServiceLayers = (changeCoordinator: LayerState, testableBuilder?: FSLBuilder): MapPlugin => {
  builder = builder ?? testableBuilder ?? PublicFSLBuilder(FULCRUM_PUBLIC_FSL_LAYER_PREFIX);

  return {
    extendMap: (mapView: MapView) => {
      const addLayerToMap = async (layer: Layer, index) => {
        const arcLayer = await builder.build(layer);
        if (arcLayer) {
          debugLog('Adding public fsl layer', layer);
          mapView.map.add(arcLayer, index);
        }
      };

      const addLayer = (index: number, layer: Layer) => {
        if (isPublicFSL(layer)) {
          addLayerToMap(layer, index);
        }
      };

      const removeLayer = (layer: Layer) => {
        if (isPublicFSL(layer)) {
          const arcLayer = mapView.map.findLayerById(builder.layerName(layer));
          if (arcLayer) {
            debugLog('Removing public fsl layer', layer);
            mapView.map.remove(arcLayer);
          }
        }
      };

      const overlays = changeCoordinator.activeOverlays();
      [...overlays].reverse().forEach((lyr, index) => addLayer(index, lyr));

      changeCoordinator.onLayerChange({ remove: removeLayer, add: addLayer });
    },
  };
};

export default PublicFeatureServiceLayers;
